import { render } from "./ProfileImg.vue?vue&type=template&id=4fb1cf7e&scoped=true"
import script from "./ProfileImg.vue?vue&type=script&lang=js"
export * from "./ProfileImg.vue?vue&type=script&lang=js"

import "./ProfileImg.vue?vue&type=style&index=0&id=4fb1cf7e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb1cf7e"]])

export default __exports__